import { AuthProvider } from '../context/AuthContext';

export const withAuth = (component: () => React.ReactNode) => () =>
  <AuthProvider>{component()}</AuthProvider>;
